/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { IAhiSubcategoryResultsContainerViewProps } from './ahi-subcategory-results-container';
// import { CategoryHierarchy } from '@msdyn365-commerce/commerce-entities';

export default (props: IAhiSubcategoryResultsContainerViewProps) => {
    return (
        <>
            <div className='sub-category-details-container '>{props.subCategoryCards && props.subCategoryCards}</div>
        </>
    );
};
